import type { IconSvgObject } from './types';

const KitchenUtensilsIcon: IconSvgObject = [
  ["path", { d: "M12.002 14V3M12.002 14C10.344 14 9 15.4354 9 16.625C9 18.375 10.344 21 12.002 21C13.6598 21 15.0039 18.375 15.0039 16.625C15.0039 15.4354 13.6598 14 12.002 14Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M5 10V21M2 3L2.87735 9.14142C2.94772 9.63407 3.36964 10 3.8673 10H6.1327C6.63036 10 7.05228 9.63407 7.12265 9.14142L8 3H2Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M18 21V14M18 14V3C19.8253 3.60844 21.1232 5.23206 21.3147 7.14658L22 14H18Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default KitchenUtensilsIcon;
